<div class="flex flex-col p-16" *ngIf="rule">
  <div class="flex flex-col gap-24">
    <twaice-fe-alerts-component-rule-evaluations-chart [ruleBk]="rule.ruleBk" />
    <twaice-fe-alerts-component-rule-transitions [ruleBk]="rule.ruleBk" />
    @if (ruleDetails$ | async; as ruleDetails) {
      @if (ruleDetails.description) {
        <div class="flex flex-col gap-8 px-12">
          <span class="text-base leading-[1]">Description</span>
          <p class="text-tertiary-text text-sm mb-0 whitespace-pre-line">
            {{ ruleDetails.description }}
          </p>
        </div>
      }
    }
    @if (minBreachDurationLabel$ | async; as minBreachDurationLabel) {
      <div class="flex items-center gap-16 px-12 text-sm">
        <span class="text-tertiary-text">Minimum breach duration</span>
        <span class="flex items-center gap-4">
          {{ minBreachDurationLabel }}
          <twaice-fe-svg-icon
            name="info-circle"
            source="tabler"
            size="14px"
            nz-tooltip
            nzTooltipTitle="All conditions must be met for the selected time period"
          />
        </span>
      </div>
    }
    <ng-container *ngComponentOutlet="sensorTimeSeriesComponent$ | async; inputs: sensorTimeSeriesComponentParams"></ng-container>
    <twaice-fe-alerts-component-rule-actions [ruleBk]="rule.ruleBk" />
  </div>
</div>
